import { useEffect, useState } from 'react';

export function useRectDrawing(
    pdfLayersRef: React.RefObject<HTMLDivElement | null>,
    dimension: { width: number; height: number },
    setPendingRect: React.Dispatch<React.SetStateAction<{ x1: number; y1: number; x2: number; y2: number } | null>>,
    setPendingComment: React.Dispatch<React.SetStateAction<string>>,
) {
    const [rectDragging, setRectDragging] = useState(false);
    const [rectDraft, setRectDraft] = useState<{ x1: number; y1: number; x2: number; y2: number } | null>(null);

    const resetRect = () => {
        setRectDragging(false);
        setRectDraft(null);
    };

    useEffect(() => {
        const onMove = (e: MouseEvent) => {
            if (!rectDragging) return;
            const layers = pdfLayersRef.current;
            if (!layers || !dimension.width || !dimension.height) return;
            const base = layers.getBoundingClientRect();
            const px = Math.max(0, Math.min(dimension.width, e.clientX - base.left));
            const py = Math.max(0, Math.min(dimension.height, e.clientY - base.top));
            setRectDraft((prev) => prev ? { ...prev, x2: px / dimension.width, y2: py / dimension.height } : prev);
        };
        const onUp = () => {
            if (!rectDragging) return;
            setRectDragging(false);
            setRectDraft((prev) => {
                if (!prev) return null;
                const w = Math.abs(prev.x2 - prev.x1) * dimension.width;
                const h = Math.abs(prev.y2 - prev.y1) * dimension.height;
                if (w < 5 && h < 5) return null;
                setPendingRect(prev);
                setPendingComment('');
                return null;
            });
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        return () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
    }, [rectDragging, dimension, pdfLayersRef, setPendingRect, setPendingComment]);

    return { rectDragging, setRectDragging, rectDraft, setRectDraft, resetRect };
}
